//jslint browser: true
/* esversion: 6 */
/*globals $, document, jQuery */

require('./chatbox').init();

window.tMultiplier = 0.8;

function randrange(min, max) {
  return Math.floor(Math.random() * (max - min) + min);
}

var BarrierWrapperHitException, FormatNumberLength, _remoteIsTyping,
  activate_chatbot, box, cascadeDelaySend, conversation, debug,
  disconnect_action, fakeConnect, getResponse,
  getSimulatedReadDelay, getSimulatedResponseDelay, isConsoleConnected,
  isTyping, log, messageDelayed, normalResponse, num, randrange,
  resetConversation, semnick, session_id, splitMessage, splitWithDelay;


cascadeDelaySend = function(chatbox, sender, fragments, callback) {
  if (callback == null) {
    callback = function() {}
    ;
  }
  isTyping(true);
  return window.setTimeout(function() {
    isTyping(false);
    if (!fragments[0].match('^\s*$')) {
      chatbox.addMsg(sender, fragments[0]);
    }
    if ((fragments = fragments.slice(1)).length) {
      if (isConsoleConnected()) {
        cascadeDelaySend(chatbox, sender, fragments, callback);
      }
    }
    if (fragments.length === 0) {
      if (callback) {
        callback();
      }
    }
    return fragments;
  }, (getSimulatedResponseDelay(
    fragments[0].length)) * window.tMultiplier);
}
;
BarrierWrapperHitException = void 0;
FormatNumberLength = void 0;
box = void 0;
conversation = void 0;
debug = void 0;
disconnect_action = void 0;
fakeConnect = void 0;
getResponse = void 0;
messageDelayed = void 0;
normalResponse = void 0;
num = void 0;
randrange = void 0;
resetConversation = void 0;
semnick = void 0;
session_id = void 0;
splitWithDelay = void 0;
session_id = null;
conversation = [];
debug = false;


if (location.port == 8008) {
  window.tMultiplier = 0;
}
randrange = function(min, max) {
  return Math.floor(Math.random() * (max - min) + min);
}
;
FormatNumberLength = function(num, length) {
  var r;
  r = void 0;
  r = '' + num;
  while (r.length < length) {
    r = '0' + r;
  }
  return r;
}
;

_remoteIsTyping = false;
isTyping = function(setstate) {
  var count;
  if (setstate == null) {
    setstate = null;
  }
  count = 0;
  if (setstate === null) {
    return _remoteIsTyping;
  } else if (setstate !== _remoteIsTyping) {
    _remoteIsTyping = setstate;
    $('div', '#chatbox').each(function(index) {
      if ($(this)[0].innerHTML.match(/...is typing...<\/span>$/)) {
        count++;
        if (count > 1 || setstate === false) {
          $(this).hide();
          $(this).remove();
          return count--;
        }
      }
    });
    if (setstate === true && count === 0) {
      window.chatbot.chatbox('option', 'boxManager').addMsg('notice', '...' + semnick + ' is typing...');
    }
  }
  return _remoteIsTyping;
}
;
getSimulatedReadDelay = function(len) {
  return getSimulatedResponseDelay(len, 80) + 250;
}
;
getSimulatedResponseDelay = function(clen, wpm) {
  var delay, rtt;
  if (wpm == null) {
    wpm = 120;
  }
  rtt = randrange(90, 120);
  delay = clen / ((wpm * 6) / 60);
  return delay * 1000;
}
;
fakeConnect = function(host, ip, callback) {
  return window.chatbot
    .chatbox('option', 'boxManager').addMsg("notice",
      connected_sysmsg);
}
;
splitMessage = function(message) {
  var prepped, subMessages;
  prepped = message
    .replace(/(\S[.?!]+)(?=\s+[^?!.]{60})/g, '$&\^\^\^');
  subMessages = prepped.split(/\s*\^\^\^\s*/g);
  return subMessages;
}
;
disconnect_action = function(chatbox, data) {
  var boxElem = $('#ui-chatbox-outer');
  boxElem.removeClass('ui-chatbox-cts');
  var error, msg, s;
  s = data.selected_response.split(RegExp(' \\* '));
  msg = splitMessage(s[0]);
  error = Array(s[1]);
  return window.chatbot.chatbox('option', 'boxManager')
    .addMsg(semnick, msg, function(error) {
      boxElem.removeClass('ui-chatbox-input-ready');
      return setTimeout(function() {
        return (function(error) {
          window.chatbot.chatbox(
            'option', 'boxManager').addMsg('error',
              error);
          return setTimeout(function() {
            window.chatbot.chatbox(
              'option', 'boxManager').addMsg(
                "notice", "Console connection lost.");
            $('.ui-chatbox-input').remove();
            boxElem
              .removeClass('ui-chatbox-connecting')
              .removeClass('ui-chatbox-cts')
              .removeClass('ui-chatbox-connected')
              .addClass('ui-chatbox-disconnected');
          }, 2000 * window.tMultiplier);
        })(s[1]);
      }, 1500 * window.tMultiplier);
    });
}
;
BarrierWrapperHitException = function() {
  this.message = 'Barrier hit';
  return this.toString = function() {
    return this.message = 'Barrier hit';
  }
  ;
}
;
isConsoleConnected = function() {
  return $('.input_ta').attr('disabled') !== 'disabled';
}
;
getResponse = function(msg) {
  if (msg == '***') {
    disconnect_action(chatbox, {
      'selected_response': 'BAH * QUITs'});
    return ;
  }
  return $.getJSON('/chat/', {
    q: msg
  }).done(function(data) {
    var chatbox, fragments;
    chatbox = void 0;
    if (data.session_id) {
      session_id = data.session_id;
      $('.ui-chatbox-sessionid').text(data.session_id);
    }
    conversation = conversation.concat([data]);
    chatbox = window.chatbot.chatbox('option', 'boxManager');
    if (data.nick === 'notice') {
      return chatbox.addMsg("notice", data.selected_response);
    } else if (data.selected_response.match(RegExp(' \\* '))) {
      return disconnect_action(chatbox, data);
    } else {
      fragments = splitMessage(data.selected_response);
      chatbox = window.chatbot.chatbox('option', 'boxManager');

      return setTimeout(function() {
        return chatbox.addMsg(semnick, fragments);
      }, (getSimulatedReadDelay(msg.length)) * window.tMultiplier);
    }
  });
}

resetConversation = function() {
  var num;
  var semnick;
  num = void 0;
  semnick = void 0;
  num = randrange(1, 512);
  semnick = 'wrkstn' + FormatNumberLength(num, 3);
  conversation = [];
  return session_id = null;
}


if (debug)
  window.tMultiplier = 0;

semnick = 'wrkstn' + FormatNumberLength(randrange(1, 512), 3);

activate_chatbot = function () {
  window.chatbot = $('<div></div>')
    .css('display', 'block')
    .chatbox({
    id: 'local',
    user: {
      key: 'value'
    },
    title: 'Semaphore DevConsole',
    messageSent: function(id, user, msg) {
      var box = window.chatbot.chatbox('option', 'boxManager');
      box.addMsg(id, msg);
      if (isConsoleConnected() && isTyping() === false)
        getResponse(msg);
    }
  });

  window.setTimeout(function() {
    var chatbox, connected_sysmsg;
    connected_sysmsg = 'Breakpoint Encountered @ site.js:47';
    chatbox = window.chatbot.chatbox('option', 'boxManager');
    chatbox.addMsg('error', connected_sysmsg);
    return window.setTimeout(function() {
      $('#ui-chatbox-outer')
        .addClass('ui-chatbox-connecting');
      chatbox.addMsg('notice', 'Found remote debugger at ' + semnick +
        '.semaphore-studios.com...');
      return window.setTimeout(function() {
        chatbox.addMsg('notice', 'Connection Established.');
        $('#ui-chatbox-outer')
          .removeClass('ui-chatbox-disconnected')
          .removeClass('ui-chatbox-connecting')
          .addClass('ui-chatbox-connected');
        window.setTimeout(function() {
          getResponse('* user joined the channel');
        }, randrange(200, 300) * window.tMultiplier);
      }, randrange(300, 600) * window.tMultiplier);
      // Connected.
    }, randrange(300, 600) * window.tMultiplier);
    // Debugger connect
  }, randrange(200, 500) * window.tMultiplier);
}

export {activate_chatbot};
export default activate_chatbot;

// vim: ts=2:sw=2:ss=2:et



// WEBPACK FOOTER //
// ./webpack/chatbot/index.js